import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  PRIVACYPOLICY: {
    path: `${baseRoutes.userBaseRoutes}privacy-policy`,
  },
};

export default accessRoute;
